/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { TableCell } from '@/components/TableCell/TableCell';
import { isValidElement } from 'react';
import sharedStyles from '../../sharedStyles.module.scss';

export type ComparisonTableBodyCellProps = {
  attributeValue: string | JSX.Element | null;
};

export function ComparisonTableBodyCell({ attributeValue }: ComparisonTableBodyCellProps) {
  return (
    <TableCell align="center" className={sharedStyles.comparisonCell}>
      {isValidElement(attributeValue) ? (
        attributeValue
      ) : (
        <p className={sharedStyles.cellText}>{attributeValue ?? '-'}</p>
      )}
    </TableCell>
  );
}
